module.exports = __webpack_public_path__ + "static/media/icon-email.10d4e323.svg";